import { webKnots } from '../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const wt1Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.moveTo(675, 284) // 右上
  ctx.quadraticCurveTo(670, 280, 664, 281) //
  ctx.quadraticCurveTo(652, 277, 653, 263) //
  ctx.quadraticCurveTo(652, 256, 648, 257) //
  ctx.quadraticCurveTo(674, 242, 663, 212) //
  ctx.quadraticCurveTo(665, 202, 665, 202) //
  ctx.quadraticCurveTo(658, 201, 656, 214) //
  ctx.quadraticCurveTo(657, 220, 649, 223) //
  ctx.quadraticCurveTo(642, 233, 637, 232) //
  ctx.quadraticCurveTo(637, 217, 633, 208) //
  ctx.quadraticCurveTo(629, 208, 626, 202) //
  ctx.quadraticCurveTo(614, 162, 562, 175) //
  ctx.quadraticCurveTo(575, 178, 601, 205) //
  ctx.quadraticCurveTo(601, 200, 611, 214) //
  ctx.quadraticCurveTo(600, 210, 600, 214) //
  ctx.quadraticCurveTo(605, 215, 605, 222) //
  ctx.quadraticCurveTo(590, 224, 575, 217) //
  ctx.quadraticCurveTo(527, 212, 495, 247) //
  ctx.quadraticCurveTo(519, 237, 538, 248) //
  ctx.quadraticCurveTo(569, 273, 594, 268) //
  ctx.quadraticCurveTo(593, 309, 576, 321) //
  ctx.quadraticCurveTo(594, 314, 600, 301) //
  ctx.quadraticCurveTo(603, 294, 613, 292) //
  ctx.quadraticCurveTo(601, 309, 603, 323) //
  ctx.quadraticCurveTo(605, 313, 609, 308) //
  ctx.quadraticCurveTo(610, 314, 610, 314) //
  ctx.quadraticCurveTo(613, 298, 629, 301) //
  ctx.quadraticCurveTo(641, 299, 643, 290) //
  ctx.quadraticCurveTo(646, 282, 663, 295) //
  ctx.quadraticCurveTo(669, 289, 675, 291) //
  ctx.quadraticCurveTo(673, 284, 675, 284) //

  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  // 内側
  ctx.moveTo(555, 87) // 左上
  ctx.quadraticCurveTo(511, 166, 489, 252) // 左下
  ctx.quadraticCurveTo(505, 313, 581, 355) // 右下
  ctx.quadraticCurveTo(624, 326, 687, 274) //
  ctx.quadraticCurveTo(660, 155, 555, 87) //
  // デザイン周辺
  ctx.moveTo(677, 280) // 右上
  ctx.quadraticCurveTo(653, 280, 656, 256) // 左下
  ctx.quadraticCurveTo(677, 239, 668, 215) // 左下
  ctx.moveTo(658, 196) // 上
  ctx.quadraticCurveTo(654, 218, 641, 225) //
  ctx.quadraticCurveTo(637, 204, 631, 203) //
  ctx.quadraticCurveTo(620, 152, 549, 173) //
  ctx.quadraticCurveTo(574, 182, 602, 210) //
  ctx.quadraticCurveTo(591, 212, 591, 212) //
  ctx.quadraticCurveTo(597, 216, 597, 218) //
  ctx.quadraticCurveTo(530, 197, 489, 250) //
  ctx.quadraticCurveTo(527, 239, 546, 258) //
  ctx.quadraticCurveTo(570, 275, 590, 273) //
  ctx.quadraticCurveTo(590, 314, 563, 325) //
  ctx.quadraticCurveTo(593, 325, 605, 298) //
  ctx.quadraticCurveTo(597, 317, 603, 329) //
  ctx.quadraticCurveTo(608, 315, 609, 315) //
  ctx.quadraticCurveTo(610, 319, 610, 319) //
  ctx.quadraticCurveTo(614, 300, 634, 305) //
  ctx.quadraticCurveTo(648, 298, 646, 290) //
  ctx.quadraticCurveTo(659, 294, 659, 297) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
}
